import React from 'react';

import { Table } from './Table';
import { PaymentScheduleType } from './types';
import styles from './styles.module.css';

const GENERIC_MONTHLY_PAYMENTS_DISCLAIMER =
  'Installment fees are charged to cover the cost of payment processing and bill generation.';

const MONTHLY_PAYMENTS_DISCLAIMER =
  'All payment plan options except "Pay in full" include a {installmentFee} installment fee on future payments. ';

const replacePlaceholders = (
  template: string,
  values: { [key: string]: string }
) => {
  return template.replace(/\{(\w+)\}/g, (_, key) => values[key] || '');
};

export function isGreaterThanZero(value: string | null | undefined): boolean {
  if (!value) return false;

  const numericString = value.replace(/[^0-9.]/g, '');

  const number = parseFloat(numericString);

  return !isNaN(number) && number > 0;
}

export const PaymentSchedule: React.FC<PaymentScheduleType> = (props) => {
  const { paymentPlan } = props;

  const buildFeesDisclaimer = () => {
    // No disclaimer needed for Pay in Full plans
    if (paymentPlan.paymentFrequencyIdentifier === 'in_full') {
      return '';
    }

    const installmentFee = paymentPlan.installmentFeeAmount!;

    const disclaimer = replacePlaceholders(MONTHLY_PAYMENTS_DISCLAIMER, {
      installmentFee,
    });

    return `${disclaimer} ${GENERIC_MONTHLY_PAYMENTS_DISCLAIMER}`;
  };

  return (
    <div className={styles.paymentSchedule}>
      <Table
        data-testid="payment-schedule-table"
        headers={['Due date', 'Amount due']}
        rows={paymentPlan.paymentSchedule.map((scheduleItem) => ({
          first: scheduleItem.date,
          second: scheduleItem.amount,
        }))}
        footer={<></>}
      />
      {isGreaterThanZero(paymentPlan.installmentFeeAmount) && (
        <p className={styles.feesDisclaimer}>{buildFeesDisclaimer()}</p>
      )}
    </div>
  );
};
